import { Component, Prop, Vue } from 'vue-property-decorator';
import { userEngagementRoleMapping } from '@/helpers';
import { UserEngagementDTO } from '@/models';
import Avatar from '@/components/common/avatar/Avatar.vue';

@Component({
  components: {
    Avatar
  }
})
export default class MemberHoverInfo extends Vue {
  @Prop() members: UserEngagementDTO[];

  private isDropUp = false;

  $refs!: {
    dropDown: HTMLDivElement;
  };

  displayRole(userEngagementRole: string): string {
    return userEngagementRoleMapping[userEngagementRole];
  }

  isHigherThanBody(elem: HTMLElement): boolean {
    const boundingClientRect = elem.getBoundingClientRect();
    return boundingClientRect.bottom > (window.innerHeight || document.documentElement.clientHeight);
  }

  onMouseEnter(): void {
    const dropDownElement = this.$refs.dropDown;
    if (dropDownElement) {
      const checkElementOutsideWiewPort = this.isHigherThanBody(dropDownElement);
      if (this.isDropUp) {
        return;
      }
      this.isDropUp = checkElementOutsideWiewPort;
    } else {
      this.isDropUp = false;
    }
  }

  onMouseLeave(): void {
    this.isDropUp = false;
  }
}
